"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgThumbsDownFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M6.3 6.15a11.73 11.73 0 00-5 7 14.81 14.81 0 00.52 8.19l.29.61h7.58l-.5 4.31a3.76 3.76 0 00.57 2.84 4.94 4.94 0 004.06 1.9h2.1l.08-.92a15 15 0 012-6 20.65 20.65 0 012-2.69V6H6.54zM22 4h8v17h-8z" })));
}
exports.default = SvgThumbsDownFilled;
//# sourceMappingURL=ThumbsDownFilled.js.map